import {
  FORM_AUTO,
  FORM_BP,
  FORM_CONSUMO,
  FORM_GS,
  FORM_MG,
  FORM_MG_NO_SHOP,
  FORM_REPSOL,
} from '@app/@core/constants/requests.constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestDataReponseDTO, RequestFormInstantCreditDTO } from '../model/requests-model';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable()
export class RequestsSaveSendApi {
  constructor(private _http: HttpClient) {}

  postSaveRequest(requestFromDTO: any, request_type: string): Observable<RequestDataReponseDTO> {
    //comprobamos que formulario es el que se ha rellenado y guardamos
    if (request_type === FORM_BP) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSaveCard,
        requestFromDTO
      );
    } else if (request_type === FORM_MG) {
      console.log('request mango');
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSaveCardMg,
        requestFromDTO
      );
    } else if (request_type === FORM_MG_NO_SHOP) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSaveCardMgNoShop,
        requestFromDTO
      );
    } else if (request_type === FORM_CONSUMO || request_type === FORM_REPSOL || request_type === FORM_GS) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSaveConsume,
        requestFromDTO
      );
    } else if (request_type === FORM_AUTO) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSaveAutos,
        requestFromDTO
      );
    }
  }

  postSaveRequestAutos(requestFromDTO: any): Observable<RequestDataReponseDTO> {
    return this._http.post<RequestDataReponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlSaveAutos,
      requestFromDTO
    );
  }

  postSendRequestAutos(requestFromDTO: any): Observable<RequestDataReponseDTO> {
    return this._http.post<RequestDataReponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlSendAutos,
      requestFromDTO
    );
  }

  postSaveRackRequestAutos(requestFromDTO: any): Observable<RequestDataReponseDTO> {
    return this._http.post<RequestDataReponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlSaveRackAutos,
      requestFromDTO
    );
  }

  postSendRequest(requestFromDTO: any, request_type: string): Observable<RequestDataReponseDTO> {
    //comprobamos que formulario es el que se ha rellenado y enviamos
    if (request_type === FORM_BP) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSendCard,
        requestFromDTO
      );
    } else if (request_type === FORM_MG) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSendCardMg,
        requestFromDTO
      );
    } else if (request_type === FORM_MG_NO_SHOP) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSendCardMgNoShop,
        requestFromDTO
      );
    } else if (request_type === FORM_CONSUMO || request_type === FORM_REPSOL || request_type === FORM_GS) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSendConsume,
        requestFromDTO
      );
    } else if (request_type === FORM_AUTO) {
      return this._http.post<RequestDataReponseDTO>(
        environment.URL_BASE_REQUEST + environment.subUrlSendAutos,
        requestFromDTO
      );
    }
  }

  //IC

  postSendRequestIC(requestFormInstantCreditDTO: RequestFormInstantCreditDTO): Observable<RequestDataReponseDTO> {
    return this._http.post<RequestDataReponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlSendIC,
      requestFormInstantCreditDTO
    );
  }

  postGetTestRequest(requestFromDTO: any): Observable<RequestDataReponseDTO> {
    return this._http.post<RequestDataReponseDTO>(
      environment.URL_BASE_REQUEST + environment.subUrlgetTestCard,
      requestFromDTO
    );
  }
}
